<template>
  <div id="app" :class="{'showBroad':haveBroad}">
    <router-view />
    <thread-dialog v-show="callStarted||thread"></thread-dialog>
    <login-abnormal v-if="loginAbnormalFlag" :type="loginAbnormalType"></login-abnormal>
    <export-tips v-if="exportFlag" :isHidden="isHidden"></export-tips>
  </div>
</template>

<script>
import config from "./config";
import { mapActions, mapState } from "vuex";
import Vue from "vue";
import VueSocketIO from './common/socket/index';
import { cookieManager, getItem } from "./common/utils";
import callSub from "./components/report/callSub.vue";
import threadDialog from "./components/report/threadDialog.vue";
import loginAbnormal from "./components/account/loginAbnormal.vue";
import exportTips from "./components/account/exportTips.vue";
import { SITE_COLOR_KEY_INDEX } from "./common/appConstant";
let mainCSS = __VERSION === 'HQ' ? require('../static/css/main.hq.css') : require('../static/css/main.css');
export default {
  name: "app",
  data () {
    return {
      haveBroad: false,
      path: this.$route.path,
      token: getItem('local', config.session.loginKey)
    };
  },
  components: {
    callSub,
    threadDialog,
    loginAbnormal,
    exportTips
  },
  computed: {
    ...mapState({
      baseInfo: state => state.account.baseInfo,
      broadInfo: state => state.broadCast.broadInfo,
      callStarted: state => state.callInfo.callStarted,
      thread: state => state.callInfo.thread,
      loginAbnormalFlag: state => state.loginAbnormal.loginAbnormalFlag,
      loginAbnormalType: state => state.loginAbnormal.loginAbnormalType,
      exportFlag: state => state.exportTips.exportFlag,
      isHidden: state => state.exportTips.isHidden
    })
  },
  watch: {
    broadInfo (val) {
      this.haveBroad = this.broadInfo.text ? true : false;
    },
    baseInfo(v) {
      if( v ) {
        const customSiteColor = v.customSiteColor || {};
        for( let k in SITE_COLOR_KEY_INDEX ) {
          if( k in customSiteColor ) {
            // this.$el.style.setProperty( '--' + SITE_COLOR_KEY_INDEX[ k ], customSiteColor[ k ] );
            // if( document.querySelector('.el-dialog__wrapper') ) {
            //   document.querySelector('.el-dialog__wrapper').style.setProperty( '--' + SITE_COLOR_KEY_INDEX[ k ], customSiteColor[ k ] );
            // }
            if( document.querySelector('body') ) {
              document.querySelector('body').style.setProperty( '--' + SITE_COLOR_KEY_INDEX[ k ], customSiteColor[ k ] );
            }
            //document.querySelectorAll('div').style.setProperty( '--' + SITE_COLOR_KEY_INDEX[ k ], customSiteColor[ k ] );
          }
        }
      }
    }
  },
  methods: {
    ...mapActions(["getBroadCast"]),
  },
  created(){
   try{
     Vue.use(
       new VueSocketIO({
         debug: false,
         connection: window.location.hostname==='localhost'? 'https://test.lixiaoskb.com':this.getOrigin(),
         query: { sid: 12312 }
       })
     );
   }catch(error){
     console.log(error);
   }
  },
  mounted () {
    let token = this.getItem("local", "twe_logged");
    let userInfo = this.getItem("local", "twe_userInfo");
    if (userInfo) {
      userInfo = JSON.parse(userInfo);
      /*禁用账户不发请求*/
      if (userInfo.disable == true) {
        return;
      }
    }
    if (token) {
      const middle = token.split(".")[1];
      const expiry = JSON.parse(atob(middle)).exp * 1000;
      const now = Date.now();
      if (now < expiry) {
        if (this.baseInfo.email) {
          this.getBroadCast();
          this.haveBroad = this.broadInfo.text ? true : false;
        }
        let registed = this.getItem("session", "callRegisted");
        if (registed != "1") {
          this.RegistCall();
        }
      } else {
        console.log("token已过期");
      }
    }
  }
};
</script>

<style>
/* @import "../static/css/main.css"; */
@import "../static/css/common.css";
.showBroad #HomeMainHeader,
.showBroad .sidebar,
.showBroad #homeMainContent,
.showBroad .card-wrap,
.showBroad .contact {
  margin-top: 38px;
}
.showBroad .report .card-wrap{
  margin-top: 0;
}

.showBroad #termOfUse {
  bottom: 48px;
}
.showBroad .release-note {
  z-index: 11111;
}
.showBroad .tabs-fiexd,
.showBroad .nav-fiexd {
  margin-top: 38px;
}
.showBroad .top-handle.toFixed {
  top:98px !important;
}
.showBroad .top-handle.toFixed.no-top{
  top:40px !important;
}
.helpTip {
  background: -32px 0 url("../src/assets/help.png") no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/App.vue